module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-bar"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "bar",
    style: ("height: " + _vm.percentage)
  }), _c('div', {
    staticClass: "icon",
    class: _vm.icon_class,
    style: ("bottom: calc(" + _vm.percentage + " + 4px)")
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-220c63e8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/vertical_bar.vue
// module id = 1046
// module chunks = 1